"use client"

import { useRemoteClientPost } from "@/configs/http-client"
import { Endpoints } from "@/remote/endpoints"
import { useLocalStorage } from "@/remote/local-storage"
import { PaginationDemo } from "@/view/components/pagination"
import { TableClient } from "@/view/components/table-client"
import { usePagination, useToast } from "@/view/hooks"
import type { ClientFormData } from "@/view/validators/client-validator"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { Input } from "../../../components/ui/input"
import { Button } from "../../../components/ui/button"
import { X } from "lucide-react"

export function DisplayClient() {
  const { httpClientPost } = useRemoteClientPost()

  const { showToast } = useToast()
  const { backPage, nextPage } = usePagination()
  const { getUnitId } = useLocalStorage()
  const [data, setData] = useState<ClientFormData[]>([])
  const [params] = useSearchParams()
  const [controlPage, setControlPage] = useState(0)
  const [searchName, setSearchName] = useState("")
  const [loading, setLoading] = useState(true)

  const [pageInfo, setPageInfo] = useState({
    page: 0,
    total: 0,
    totalPages: 0,
  })
  const quantityForPage = 20

  const getNextPage = () => {
    nextPage(pageInfo.page, pageInfo.totalPages, setControlPage)
    setPageInfo((prev) => ({ ...prev, page: controlPage }))
  }

  const getBackPage = () => {
    backPage(pageInfo.page, setControlPage)
    setPageInfo((prev) => ({ ...prev, page: controlPage }))
  }

  const fetchData = async () => {
    try {
      const response = await httpClientPost(
        `${Endpoints.client}/filtro?page=${controlPage}&size=${quantityForPage}&order=desc&sort=id`,
        {
          idUnidade: [params.get("id") ?? getUnitId()],
          status: 1,
          nome: searchName,
        },
      )

      const data = response?.data?.data ?? {}
      const content = data?.content ?? []
      const page = data?.pageable?.pageNumber ?? 0
      const totalPages = data?.totalPages
      const total = data?.totalElements
      //console.log(page, totalPages, total)

      setData(content)
      setPageInfo({
        page: page,
        total: total,
        totalPages: totalPages,
      })

      if (loading){
        showToast("Dados carregados com sucesso!", "success")
      }

      setLoading(false)
      
    } catch (error) {
      console.error("Erro ao buscar dados:", error)
    }
  }

  const handleRefresh = () => {
    fetchData()
  }

  const clearSearch = () => {
    setSearchName("")
    setControlPage(0)
  }

  useEffect(() => {
    if (searchName.length === 0 || searchName.length >= 3) {
      handleRefresh()
    }
  }, [controlPage, params, searchName])

  return (
    <>
      <div className="mb-4 flex items-center gap-2 max-w-sm">
        <Input
          type="text"
          placeholder="Pesquisar por cliente."
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          className="flex-1"
        />
        {searchName && (
          <Button variant="outline" size="icon" onClick={clearSearch} className="shrink-0">
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
      <TableClient data={data} getRefreshList={handleRefresh} />
      <PaginationDemo
        totalForPage={quantityForPage}
        back={getBackPage}
        next={getNextPage}
        page={pageInfo.page}
        total={pageInfo.total}
        labelItem="clientes"
      />
    </>
  )
}
